type RawFeatureFlag = {
  name: string;
  activeVersion: string | null;
};

export const normalizeFeatureFlags = (
  rawFlags: RawFeatureFlag[],
): Record<string, string | null> => {
  return Object.fromEntries(rawFlags.map((flag) => [flag.name, flag.activeVersion]));
};
